import { Dispatch } from "redux";
import { errorHandler } from "../../helpers/Functions";
import { Pagination } from "../../Interfaces/Interfaces";
import AgentService from "../../services/AgentService";
import ConfigService from "../../services/ConfigService";

export const onboardAgents = (data: any) => {
  const api = new AgentService().onboardAgents(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: errorHandler(res),
              successful: false,
            },
          });
        }
      })
      .catch((err) => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: err.message,//"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const updateAgent = (data: any) => {
  const api = new AgentService().updateAgent(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: errorHandler(res),
              successful: false,
            },
          });
        }
      })
      .catch((err) => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: err.message,//"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const requestAgentFloat = (data: any) => {
  const api = new AgentService().requestAgentFloat(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: errorHandler(res),
              successful: false,
            },
          });
        }
      })
      .catch((err) => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: err.message,
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAgents = (data: Pagination) => {
  const api = new AgentService().getAgents(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "AGENTS",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: errorHandler(res),
          });
        }
      })
      .catch((err) => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: err.message,//"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const getAllAgentsActions = (data: any) => {
  const api = new AgentService().getAllAgents(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        // console.log({ agent: res });

        dispatch({
          type: "GET_ALL_AGENTS",
          payload: res.items,
        });
      })
      .catch(() => {
        // send err to application
        // dispatch({
        //   type: "ALERT",
        //   payload: {
        //     message: "Network request failed",
        //     successful: false,
        //   },
        // });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const getAgentByPhoneNumber = (data: any) => {
  data = JSON.parse(data.whereCondition).name;
  const api = new AgentService().getAgentByPhoneNumber(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        console.log({ agent: res }, "results");   
        if (res.successful) {
          dispatch({
            type: "GET_ALL_AGENTS",
            payload: [res.result],
          });
          dispatch({
            type: "ALERT",
            payload: {
              message: '',
            },
          });
        } else {
          dispatch({
            type: "GET_ALL_AGENTS",
            payload: [],
          });
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
            // payload: errorHandler(res),
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const getAgentsPerformance = (data: Pagination) => {
  const api = new AgentService().getAgentsPerformance(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "AGENTS_PERFORMANCE",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: errorHandler(res),
          });
        }
      })
      .catch((err) => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: err.message,//"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getStateCordinatorPerformance = (data: Pagination) => {
  const api = new AgentService().getStateCordinatorPerformance(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "AGENTS_PERFORMANCE",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: errorHandler(res),
          });
        }
      })
      .catch((err) => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: err.message,//"Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAggregatorPerformanceAction = (data: Pagination) => {
  const api = new AgentService().getAggregatorPerformanceService(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "AGGREGATOR_PERFORMANCE_LIST",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: errorHandler(res),
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getLocationPerformanceAction = (data: Pagination) => {
  const api = new AgentService().getLocationPerformanceService(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "LOCATION_PERFORMANCE_LIST",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: errorHandler(res),
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const salesCordinatorPerformanceAction = (data: Pagination) => {
  const api = new AgentService().getRMPerformanceService(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "AGGREGATOR_PERFORMANCE_LIST",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: errorHandler(res),
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAgentDetails = (id: string) => {
  const api = new AgentService().getAgentDetails(id);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "AGENT_DETAILS",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: errorHandler(res),
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAgentAccount = (id: string) => {
  const api = new ConfigService().getAgentAccounts(id);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ACCOUNTS",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: errorHandler(res),
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAgentByPhone = (phoneNumber: string) => {
  const api = new AgentService().getAgentByPhone(phoneNumber);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "AGENTS",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const inviteAgent = (data: any) => {
  const api = new AgentService().inviteAgent(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const addPNDAgentAction = (data: any) => {
  const api = new AgentService().addPNDToAgentServices(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        console.log({ res });
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const putonPNDAction = (data: any) => {
  const api = new AgentService().putAccountPNDService(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
